import React, { useContext } from "react";
import { ProformaEmployeeCostReportSectionRef } from "../../../../models/proforma-employee-cost-report/proforma-employee-cost-report-section-ref";
import { LegislationSocialSecurityCostSectionRef } from "../../../../models/legislation-social-security-cost/legislation-social-security-cost-section-ref";
import { IconButton, Tooltip } from "@mui/material";
import { HintContainer } from "./styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRefresh } from "@fortawesome/free-solid-svg-icons";
import { ProformaEmployeeCostReportContext } from "../ProformaEmployeeCostReport";

interface Props {
  currentSection: ProformaEmployeeCostReportSectionRef;
  socialSecuritySection: LegislationSocialSecurityCostSectionRef | null;
  handleUpdateSection: (updatedSection: ProformaEmployeeCostReportSectionRef) => void;
  proportionalTo: ProformaEmployeeCostReportSectionRef | null;
}

const EmployeeCostSectionRateCellHint = ({ currentSection, socialSecuritySection, handleUpdateSection }: Props) => {
  const { setReportUpdated } = useContext(ProformaEmployeeCostReportContext);

  return (
    <HintContainer>
      {
        socialSecuritySection ? (
          currentSection.systemRate !== socialSecuritySection.rate ? ( //section is a social security with different rate
            <Tooltip
              title={
                "This section is now configured as a social security with different rate than the one saved previously"
              }
            >
              <IconButton
                onClick={() => {
                  handleUpdateSection({
                    ...currentSection,
                    systemRate: socialSecuritySection.rate,
                  });
                  setReportUpdated(true);
                }}
              >
                <FontAwesomeIcon icon={faRefresh} />
                <span>{socialSecuritySection.rate}%</span>
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )
        ) : currentSection.type?.rate ? (
          currentSection.systemRate !== currentSection.type.rate ? ( //section has a different system rate => system updated after saving this report
            <Tooltip title={"section has a different system rate => system updated after saving this report"}>
              <IconButton
                onClick={() => {
                  handleUpdateSection({
                    ...currentSection,
                    systemRate: currentSection.type?.rate ?? null,
                  });
                  setReportUpdated(true);
                }}
              >
                <FontAwesomeIcon icon={faRefresh} />
                <span>{currentSection.type.rate}%</span>
              </IconButton>
            </Tooltip>
          ) : (
            ""
          )
        ) : (
          ""
        ) //the legislation section doesnt have a rate => check if section has a save systemRate
      }
      {currentSection.manualRate ? (
        !currentSection.type?.requiresInputRate ? ( //section used to have manual rate but now should follow the system one
          <Tooltip title={"section used to have manual rate but now should follow the system one"}>
            <IconButton
              onClick={() => {
                handleUpdateSection({
                  ...currentSection,
                  manualRate: null,
                  systemRate: currentSection.type?.rate ?? null,
                });
                setReportUpdated(true);
              }}
            >
              <FontAwesomeIcon icon={faRefresh} />
              <span>{currentSection.type!.rate}%</span>
            </IconButton>
          </Tooltip>
        ) : (
          ""
        )
      ) : currentSection.type?.requiresInputRate ? (
        "" // "section rate was system rate but now it can take manual rate"
      ) : (
        ""
      )}
    </HintContainer>
  );
};
export default EmployeeCostSectionRateCellHint;
